export const coloursOptions = [
  { label: 'Beige', value: 'beige' },
  { label: 'Beige clair', value: 'light_beige' },
  { label: 'Blanc', value: 'white' },
  { label: 'Bleu', value: 'blue' },
  { label: 'Bleu clair', value: 'light_blue' },
  { label: 'Bleu foncé', value: 'dark_blue' },
  { label: 'Bleu fonce', value: 'dark_blue' },
  { label: 'Gris', value: 'grey' },
  { label: 'Gris clair', value: 'light_grey' },
  { label: 'Gris foncé', value: 'dark_grey' },
  { label: 'Gris fonce', value: 'dark_grey' },
  { label: 'Jaune', value: 'yellow' },
  { label: 'Jaune clair', value: 'light_yellow' },
  { label: 'Marron', value: 'brown' },
  { label: 'Marron clair', value: 'light_brown' },
  { label: 'Marron foncé', value: 'dark_brown' },
  { label: 'Marron fonce', value: 'dark_brown' },
  { label: 'Noir', value: 'black' },
  { label: 'Orange', value: 'orange' },
  { label: 'Rouge', value: 'red' },
  { label: 'Rouge clair', value: 'light_red' },
  { label: 'Rouge foncé', value: 'dark_red' },
  { label: 'Rouge fonce', value: 'dark_red' },
  { label: 'Vert', value: 'green' },
  { label: 'Vert clair', value: 'light_green' },
  { label: 'Vert foncé', value: 'dark_green' },
  { label: 'Vert fonce', value: 'dark_green' },
  { label: 'Violet', value: 'purple' },
  { label: 'Inc.', value: 'unknown' },
];

export const documentationOptions = [
  { label: 'A jour', value: 'up_to_date' },
  { label: 'Pas à jour', value: 'not_up_to_date' },
  { label: "Pas de carnet d'entretien", value: 'none' },
];

export const duplicateKeysOptions = [
  { label: 'Oui', value: 'yes' },
  { label: 'Non', value: 'no' },
  { label: 'Ne sait pas', value: 'dontknow' },
];

export const options = [
  { label: 'Aixam', value: 'aixam' },
  { label: 'Alfa Romeo', value: 'alfa_romeo' },
  { label: 'Alpha', value: 'alpha' },
  { label: 'Aprilla', value: 'aprilla' },
  { label: 'Aston Martin', value: 'aston_martin' },
  { label: 'Audi', value: 'audi' },
  { label: 'Bentley', value: 'bentley' },
  { label: 'BMW', value: 'bmw' },
  { label: 'Bugatti', value: 'bugatti' },
  { label: 'Cadillac', value: 'cadillac' },
  { label: 'Chevrolet', value: 'chevrolet' },
  { label: 'Chrysler', value: 'chrysler' },
  { label: 'Citroen', value: 'citroen' },
  { label: 'Dacia', value: 'dacia' },
  { label: 'Daewoo', value: 'daewoo' },
  { label: 'Daihatsu', value: 'daihatsu' },
  { label: 'Dodge', value: 'dodge' },
  { label: 'Ds', value: 'ds' },
  { label: 'Ferrari', value: 'ferrari' },
  { label: 'Fiat', value: 'fiat' },
  { label: 'Ford', value: 'ford' },
  { label: 'Honda', value: 'honda' },
  { label: 'Hummer', value: 'hummer' },
  { label: 'Hyundai', value: 'hyundai' },
  { label: 'Infiniti', value: 'infiniti' },
  { label: 'Isuzu', value: 'isuzu' },
  { label: 'Iveco', value: 'iveco' },
  { label: 'Jaguar', value: 'jaguar' },
  { label: 'Jeep', value: 'jeep' },
  { label: 'Kawasaki', value: 'kawasaki' },
  { label: 'Keeway', value: 'keeway' },
  { label: 'Kia', value: 'kia' },
  { label: 'Lada', value: 'lada' },
  { label: 'Lamborghini', value: 'lamborghini' },
  { label: 'Lancia', value: 'lancia' },
  { label: 'Land Rover', value: 'land_rover' },
  { label: 'Lexus', value: 'lexus' },
  { label: 'Ligier', value: 'ligier' },
  { label: 'Lotus', value: 'lotus' },
  { label: 'Maserati', value: 'maserati' },
  { label: 'Mazda', value: 'mazda' },
  { label: 'Mercedes Benz', value: 'mercedes_benz' },
  { label: 'Mercedes', value: 'mercedes' },
  { label: 'MG', value: 'mg' },
  { label: 'Mini', value: 'mini' },
  { label: 'Mitsubishi', value: 'mitsubishi' },
  { label: 'Nissan', value: 'nissan' },
  { label: 'Opel', value: 'opel' },
  { label: 'Peugeot', value: 'peugeot' },
  { label: 'Piaggio', value: 'piaggio' },
  { label: 'Porsche', value: 'porsche' },
  { label: 'Renault', value: 'renault' },
  { label: 'Rover', value: 'rover' },
  { label: 'Saab', value: 'saab' },
  { label: 'Seat', value: 'seat' },
  { label: 'Skoda', value: 'skoda' },
  { label: 'Smart', value: 'smart' },
  { label: 'Ssangyong', value: 'ssangyong' },
  { label: 'Subaru', value: 'subaru' },
  { label: 'Suzuki', value: 'suzuki' },
  { label: 'Tesla', value: 'tesla' },
  { label: 'Toyota', value: 'toyota' },
  { label: 'Triumph', value: 'triumph' },
  { label: 'Volkswagen', value: 'volkswagen' },
  { label: 'Volvo', value: 'volvo' },
  { label: 'Yamaha', value: 'yamaha' },
];

export type OptionType = {
  value: string;
  label: string;
};

export const vehicleTypeOptions: OptionType[] = [
  { value: 'bp', label: 'Berline petite' },
  { value: 'bm', label: 'Berline moyenne' },
  { value: 'bg', label: 'Berline grande' },
  { value: 'm', label: 'Moto' },
  { value: 'fp', label: 'Fourgon petit' },
  { value: 'fm', label: 'Fourgon moyen' },
  { value: 'fg', label: 'Fourgon grand' },
  { value: 'suv', label: 'SUV' },
];

export const booleanOptions: OptionType[] = [
  { value: 'yes', label: 'Oui' },
  { value: 'no', label: 'Non' },
];

export const fuelOptions: OptionType[] = [
  { value: 'diesel', label: 'Diesel' },
  { value: 'gasoline', label: 'Essence' },
  { value: 'electric', label: 'Électrique' },
  { value: 'gasoline-hybrid', label: 'Essence - elec hybride' },
  { value: 'gasoline-rechargeable', label: 'Essence-elec rechargeable' },
  { value: 'diesel-hybrid', label: 'Gazole - elec hybride' },
  { value: 'diesel-rechargeable', label: 'Gazole-elec rechargeable' },
  { value: 'gasoline-lpg', label: 'Essence/GPL' },
  { value: 'gasoline-cng', label: 'Essence/GNV' },
  { value: 'bioethanol', label: 'Bioéthanol' },
  { value: 'flexfuel', label: 'Flexfuel' },
  { value: 'lpg', label: 'GPL' },
  { value: 'cng', label: 'GNV (Gaz Naturel)' },
  { value: 'hybrid', label: 'Hybride' },
  { value: 'other', label: 'Autre' },
  { value: 'unknown', label: 'Inconnu' },
];

// Mapping API vers nos valeurs (incluant ancienne et nouvelle API)
export const apiEnergyMapping: { [key: string]: string } = {
  // Nouvelle API (API Plaque)
  BIOETHANOL: 'bioethanol',
  DIESEL: 'diesel',
  'ESS+G.P.L.': 'gasoline-lpg',
  ESSENCE: 'gasoline',
  'ESSENCE – ELEC HYBRIDE': 'gasoline-hybrid',
  'ESSENCE-ELEC RECHARGEABLE': 'gasoline-rechargeable',
  'FLEXFUEL HYBRIDE': 'flexfuel',
  'GAZ NATUREL': 'cng',
  'GAZOLE – ELEC HYBRIDE': 'diesel-hybrid',
  'GAZOLE-ELEC RECHARGEABLE': 'diesel-rechargeable',
  GPL: 'lpg',
  ELECTRIQUE: 'electric',
  ÉLECTRIQUE: 'electric',
  'ESSENCE/éLECTRIQUE': 'gasoline-hybrid',
  'ESSENCE/ÉLECTRIQUE': 'gasoline-hybrid',
  'ESSENCE/ELECTRIQUE': 'gasoline-hybrid',

  // Mapping par ID d'énergie
  '1': 'bioethanol',
  '2': 'diesel',
  '3': 'gasoline-lpg',
  '4': 'gasoline',
  '5': 'gasoline-hybrid',
  '6': 'gasoline-rechargeable',
  '7': 'flexfuel',
  '8': 'cng',
  '9': 'diesel-hybrid',
  '10': 'diesel-rechargeable',
  '11': 'lpg',
  '12': 'electric',
  '14': 'gasoline-hybrid',

  // Variantes de casse et format pour la nouvelle API
  Diesel: 'diesel',
  'Essence/gaz de pétrole liquéfié (GPL)': 'gasoline-lpg',
  'ESSENCE /GAZ NATUREL (CNG)': 'gasoline-cng',
  'Essence/éthanol': 'flexfuel',
  GNC: 'cng',
  GNV: 'cng',
  AUTRES: 'other',
  INCONNU: 'unknown',

  // Ancienne API (MISIV) - pour rétrocompatibilité
  'ESS+ELEC HNR': 'gasoline-hybrid',
  'ESS+G.NAT': 'gasoline-cng',
  'GAZ NAT.VEH': 'cng',
  'GAZ+ELEC HNR': 'diesel-hybrid',
  GAZOLE: 'diesel',
  ELECTRIC: 'electric',
  SUPERETHANOL: 'bioethanol',
  'ESSENCE /GAZ NATUREL': 'gasoline-cng',
  'ESSENCE+ELECTRIQUE': 'gasoline-hybrid',
  'DIESEL+ELECTRIQUE': 'diesel-hybrid',
  'ESS+GPL': 'gasoline-lpg',
  'GAZOLE+GNV': 'diesel-cng',
};

// Mapping des genres de véhicules selon l'API Plaque
export const genreOptions: readonly OptionType[] = [
  // Véhicules particuliers et utilitaires
  { value: 'vp', label: 'VP' },
  { value: 'ctte', label: 'CTTE' },
  { value: 'vasp', label: 'VASP' },
  { value: 'cam', label: 'CAM' },

  // Deux-roues et assimilés
  { value: 'mtl', label: 'MTL' },
  { value: 'mtt1', label: 'MTT1' },
  { value: 'mtt2', label: 'MTT2' },
  { value: 'mtte', label: 'MTTE' },
  { value: 'moto', label: 'MOTO' },
  { value: 'cl', label: 'CL' },

  // Quadricycles et véhicules spéciaux
  { value: 'qm', label: 'QM' },
  { value: 'tra', label: 'TRA' },
  { value: 'maga', label: 'MAGA' },
  { value: 'tm', label: 'TM' },
  { value: 'cycl', label: 'CYCL' },
  { value: 'tcp', label: 'TCP' },
  { value: 'trr', label: 'TRR' },

  // Remorques et autres
  { value: 'rem', label: 'REM' },
  { value: 'srem', label: 'SREM' },
  { value: 'resp', label: 'RESP' },
];

// Mapping des transmissions selon l'API Plaque
export const apiTransmissionMapping: { [key: string]: string } = {
  // Nouvelle API (API Plaque)
  A: 'AT',
  B: 'UNKNOWN',
  S: 'ST',
  V: 'AT',
  X: 'AT',

  // Ancienne API - pour rétrocompatibilité
  MECANIQUE: 'MT',
  'B.V.A.': 'AT',
  SEQUENTIELLE: 'ST',
  'VARIAT.EL': 'AT',
  'VARIAT.ME': 'AT',
  INCONNU: 'UNKNOWN',
};

export const transmissionOptions: readonly OptionType[] = [
  { value: 'AT', label: 'Automatique' },
  { value: 'MT', label: 'Manuel' },
  { value: 'ST', label: 'Séquentielle' },
  { value: 'UNKNOWN', label: 'Inconnu' },
];

export const businessTypeOptions: OptionType[] = [
  { value: 'straight_trade_in', label: 'Reprise sèche' },
  { value: 'thirty_day_sale_mandate', label: 'Mandat 30 jours' },
  { value: 'cofinancement', label: 'Skipcar+' },
];

export const vehicleOriginOptions: OptionType[] = [
  { value: 'first_hand_french', label: 'Véhicule français première main' },
  { value: 'second_hand_french', label: "Véhicule français acheté d'occasion" },
  { value: 'dealer_purchased', label: 'Véhicule acheté chez un mandataire' },
  { value: 'pro_owned', label: "Véhicule appartient à un pro. de l'automobile" },
  { value: 'imported', label: 'Importé' },
];

export const vehicleUseOptions: OptionType[] = [
  { value: 'personal_or_corporate', label: "Véhicule personnel / véhicule d'entreprise" },
  { value: 'taxi_school_rental', label: 'Taxi/VTC, Auto-école, VSL, Location' },
];

export const detentionOptions: OptionType[] = [
  { value: 'less_than_one', label: 'Inférieure à 1 an' },
  { value: 'one_or_two', label: '1 à 2 ans' },
  { value: 'more_than_two', label: 'Supérieure à 2 ans' },
];

export const testDriveOptions: OptionType[] = [
  { value: 'test_done', label: 'Essai roulant réalisé' },
  { value: 'vehicle_seen_no_test', label: 'Véhicule vu / Essai roulant non réalisé' },
  { value: 'assessment_based_on_description', label: 'Expertise faite sur base description client' },
];

export const mechanicalConditionOptions: OptionType[] = [
  { value: 'running_no_issue', label: 'Roulant / Pas de problème mécanique identifié' },
  { value: 'running_with_reserve', label: 'Roulant / Réserve état mécanique' },
  { value: 'not_running', label: 'Non roulant' },
  { value: 'accidented', label: 'Accidenté' },
];

export const conditionsExpertiseOptions: OptionType[] = [
  { value: 'normal', label: 'Normale' },
  { value: 'humidity_or_wet', label: 'Humidité / Véhicule mouillé' },
  { value: 'low_light', label: 'Faible luminosité' },
];
